module.exports = __webpack_public_path__ + "static/media/kalendarz.5499329c.svg";